export default "__VITE_ASSET__Bd90DAGc__"